module.exports = __webpack_public_path__ + "static/media/img1-2.8afda619.jpg";